export const RowsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
            <path
                d="M3.37543 4.794L11.9694 1.30091C12.3991 1.12626 12.8887 1.33606 13.0586 1.76766L14.25 4.794M6.37457 8.36946H8.62543M6.37457 10.6555H11.6254M16.5 7.08005V5.62734C16.5 5.1671 16.1269 4.794 15.6667 4.794H2.33333C1.8731 4.794 1.5 5.1671 1.5 5.62734V7.08005C2.62457 7.08005 3.75 7.84177 3.75 9.36609C3.75 10.8904 2.62543 11.6521 1.5 11.6521V13.1048C1.5 13.5651 1.8731 13.9382 2.33333 13.9382H15.6667C16.1269 13.9382 16.5 13.5651 16.5 13.1048V11.6521C15.3754 11.6521 14.25 10.5087 14.25 9.17523C14.25 7.84178 15.3754 7.08005 16.5 7.08005Z"
                stroke="#FF7F00"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const RightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7071 0.292893C25.0976 0.683417 25.0976 1.31658 24.7071 1.70711L8.70711 17.7071C8.31658 18.0976 7.68342 18.0976 7.29289 17.7071L0.292893 10.7071C-0.0976311 10.3166 -0.0976311 9.68342 0.292893 9.29289C0.683417 8.90237 1.31658 8.90237 1.70711 9.29289L7.83301 13L23.2929 0.292893C23.6834 -0.0976311 24.3166 -0.0976311 24.7071 0.292893Z"
                fill="#FF7F00"
            />
        </svg>
    );
};
